// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import {Root} from './Root';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <Root />
//   </React.StrictMode>
// );


import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import {Root} from "./Root";

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);